import { Component, OnInit } from '@angular/core'

import { DashboardVM, buildDashboardVM } from '../../data/utils/metrics-view-model.util'
import { WorklogService } from '@modules/private/worklog/data/services/worklog.service'
import { AuthService } from '@data/services/modules/auth/auth.service'

/**
 * Métricas de TI (F-156). Consume `GET /worklog/metrics`: el backend entrega los números
 * terminados (ADR-0040 · D3) y `buildDashboardVM` los convierte, UNA vez por carga, en todo lo que
 * la plantilla pinta. La plantilla no llama funciones que calculen ni creen objetos: así se evitó
 * el ciclo infinito de detección de cambios de B-062, y así debe seguir.
 *
 * La línea de tiempo de tareas en curso vive en el Mapa de trabajo (pestaña «Tiempos»): es parte
 * de operar el trabajo, no de reportarlo, y esta vista es Admin-only.
 */
@Component({
  selector: 'app-roadmap-board',
  templateUrl: './roadmap-board.component.html',
  styleUrls: ['./roadmap-board.component.scss'],
})
export class RoadmapBoardComponent implements OnInit {
  vm: DashboardVM | null = null
  /** Solo la primera carga muestra skeleton; recargar tras editar una tarea deja la vista quieta. */
  loading = true
  failed = false
  /** «Reintentar» en curso: el botón muestra que trabaja en vez de quedarse mudo. */
  retrying = false

  /** Periodo de «En qué se invirtió». */
  period = 0
  /** Lista de entregas con reparto estimado, abierta desde «Salud del dato». */
  reviewOpen = false

  /** Detalle de una tarea (mismo modal del Mapa de trabajo). */
  detailVisible = false
  detailId: string | null = null
  isDev = false

  constructor(
    private worklog: WorklogService,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.isDev = !!this.auth.getUser?.user?.isDev
    this.reload()
  }

  reload(): void {
    this.worklog.getMetrics().subscribe((m) => {
      //* Una recarga que falla no tira lo que ya se estaba viendo.
      if (m || !this.vm) {
        this.vm = m ? buildDashboardVM(m) : null
        this.period = Math.min(this.period, Math.max(0, (this.vm?.investment.periods.length ?? 1) - 1))
      }
      this.failed = !m && !this.vm
      this.loading = false
      this.retrying = false
    })
  }

  retry(): void {
    this.retrying = true
    this.reload()
  }

  openDetail(id: string): void {
    this.detailId = id
    this.detailVisible = true
  }

  /** Un cambio desde el detalle (mover, puntuar, repartir) recalcula las métricas. */
  onDetailChanged(): void {
    this.reload()
  }

  trackByKey(_: number, x: { key: string }): string {
    return x.key
  }

  trackByIndex(i: number): number {
    return i
  }
}
